import { http, type HttpResponse } from 'interfaces'
import { type PersonBaseBasicInformation } from 'services'
import { preparePayload } from 'helpers/person/personHelper'

export async function updatePersonBasicInfo (personId: number, payload: PersonBaseBasicInformation): Promise<HttpResponse<PersonBaseBasicInformation>> {
  const newPayload: any = preparePayload(payload)

  return await http.put(`/api/v1/us/people/${personId}/`, newPayload)
    .then((response) => {
      const data = response.data
      return data
    })
}

export async function getPersonBasicInfo (personId: number): Promise<PersonBaseBasicInformation> {
  return await http
    .get(`/api/v1/us/people/${personId}/`, {
    }).then(value => {
      const data = value.data
      return data
    })
}
